import { sellingPlanGroupConnection } from './fragments'

export const productConnectionFragment = /* GraphQL */ `
  fragment productConnection on ProductConnection {
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        id
        title
        vendor
        handle
        healthNeedsRaw: metafield(namespace: "filter", key: "dietary_type") {
          value
        }
        productFormRaw: metafield(namespace: "filter", key: "product_form") {
          value
        }
        ingredientsRaw: metafield(namespace: "filter", key: "ingredients") {
          value
        }
        collections(first: 100) {
          nodes {
            title
            id
          }
        }
        options {
          id
          name
          values
        }
        trimmerType: metafield(namespace: "filter", key: "trimmer_type") {
          value
        }
        isBestseller: metafield(namespace: "product", key: "bestsellertag") {
          value
        }
        isNew: metafield(namespace: "product", key: "newtag") {
          value
        }
        isBundle: metafield(namespace: "filter", key: "bundles") {
          value
        }
        priority: metafield(namespace: "search", key: "priority_index") {
          value
        }
        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }
        compareAtPriceRange {
          minVariantPrice {
            amount
          }
        }
        images(first: 1) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              url
              altText
              width
              height
            }
          }
        }
        sellingPlanGroups(first: 250) {
          ...sellingPlanGroupConnection
        }
        variants(first: 250) {
          pageInfo {
            hasNextPage
            hasPreviousPage
          }
          edges {
            node {
              id
              title
              sku
              availableForSale
              requiresShipping
              selectedOptions {
                name
                value
              }
              priceV2 {
                amount
                currencyCode
              }
              image {
                url
              }
              compareAtPriceV2 {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`

const getAllProductsQuery = /* GraphQL */ `
  query getAllProducts(
    $first: Int = 250
    $query: String = ""
    $sortKey: ProductSortKeys = RELEVANCE
    $reverse: Boolean = false
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    products(
      first: $first
      sortKey: $sortKey
      reverse: $reverse
      query: $query
    ) {
      ...productConnection
    }
  }

  ${productConnectionFragment}
  ${sellingPlanGroupConnection}
`
export default getAllProductsQuery
